import React from 'react';
import { Link } from 'react-router-dom';

export default function OrBike365Section() {
  return (
    <section id="oerbike-365" className="relative rounded-3xl overflow-hidden border border-pink-500/30 bg-gradient-to-b from-[#181229] via-[#121422] to-[#0d0f1a] p-8 sm:p-12 shadow-2xl">
      <div className="absolute top-0 right-0 w-96 h-96 bg-pink-500/10 rounded-full blur-3xl pointer-events-none -mr-20 -mt-20"></div>
      <div className="relative z-10 max-w-4xl mx-auto space-y-8">
        <div className="text-center space-y-3">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider bg-pink-500/20 text-pink-400 border border-pink-500/30">
            Medlemskab & Fællesskab hele året
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-white font-display uppercase tracking-tight">
            ØrBike 365
          </h2>
          <p className="text-xl sm:text-2xl font-bold text-pink-300 font-display">
            Fællesskabet stopper ikke, når cyklerne står stille.
          </p>
        </div>

        <div className="space-y-4 text-slate-300 text-base leading-relaxed text-center sm:text-left">
          <p>
            ØrBike er mere end én dag om året. Det er energi, oplevelser og et fællesskab, der samtidig er med til at gøre en forskel.
          </p>
          <p>
            Med ØrBike 365 kommer du lidt tættere på – hele året.
          </p>
        </div>

        <div className="bg-[#12141f]/90 border border-pink-500/20 rounded-2xl p-6 sm:p-8 space-y-4">
          <h3 className="text-lg sm:text-xl font-bold text-white font-display uppercase tracking-wide flex items-center gap-2.5">
            <span className="w-2.5 h-2.5 rounded-full bg-pink-500"></span>
            Som en del af ØrBike 365 får du blandt andet:
          </h3>
          <ul className="space-y-3 text-sm sm:text-base text-slate-200">
            <li className="flex items-start gap-3">
              <i className="fa-solid fa-circle-check text-pink-400 mt-1 shrink-0" aria-hidden="true"></i>
              <span>adgang til billetsalget før alle andre</span>
            </li>
            <li className="flex items-start gap-3">
              <i className="fa-solid fa-circle-check text-pink-400 mt-1 shrink-0" aria-hidden="true"></i>
              <span>rabat på din billet til ØrBike</span>
            </li>
            <li className="flex items-start gap-3">
              <i className="fa-solid fa-circle-check text-pink-400 mt-1 shrink-0" aria-hidden="true"></i>
              <span>adgang til særlige tilbud og muligheder – herunder sportsrejser og oplevelser</span>
            </li>
            <li className="flex items-start gap-3">
              <i className="fa-solid fa-circle-check text-pink-400 mt-1 shrink-0" aria-hidden="true"></i>
              <span>adgang til nye ØrBike 365-tiltag, som vi allerede arbejder på</span>
            </li>
            <li className="flex items-start gap-3">
              <i className="fa-solid fa-circle-check text-pink-400 mt-1 shrink-0" aria-hidden="true"></i>
              <span>og ikke mindst: Du er med til at bakke op om ØrBike og det fællesskab, vi skaber sammen</span>
            </li>
          </ul>

          <div className="pt-4 border-t border-slate-800 text-xs sm:text-sm text-pink-300 font-medium flex items-start gap-2.5">
            <i className="fa-solid fa-circle-info text-pink-400 mt-0.5 shrink-0" aria-hidden="true"></i>
            <span>
              <strong>OBS!</strong> Der kommer mere information om ØrBike 365 i starten af 2027 og vi glæder os til at løfte sløret for pris, fordele mv.
            </span>
          </div>
        </div>

        <div className="p-6 sm:p-8 rounded-2xl bg-gradient-to-r from-pink-950/40 via-purple-950/40 to-slate-900 border border-pink-500/40 text-center space-y-4">
          <h4 className="text-2xl font-black text-white font-display uppercase tracking-tight">
            Skal du med i ØrBike 365?
          </h4>
          <p className="text-slate-300 text-sm sm:text-base max-w-xl mx-auto">
            Så udfyld vores kontaktformular og vælg “ØrBike 365” og tilkendegiv allerede nu din interesse.
          </p>
          <p className="text-pink-300 font-display font-semibold text-sm">
            Vi glæder os til at have dig med – ikke bare til ØrBike, men hele året rundt.
          </p>
          <div className="pt-2 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/orbike-365"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-gradient-to-r from-pink-500 to-purple-600 text-white font-bold text-sm uppercase tracking-wider shadow-[0_0_25px_rgba(255,42,141,0.5)] hover:scale-105 transition-transform"
            >
              <span>Læs mere om ØrBike 365</span>
              <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true"></i>
            </Link>
            <Link
              to="/kontakt?emne=ØrBike 365"
              className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-slate-800/80 hover:bg-slate-700 text-slate-200 border border-slate-700 font-semibold text-sm uppercase tracking-wider transition-all"
            >
              <i className="fa-solid fa-envelope text-pink-400" aria-hidden="true"></i>
              <span>Tilkendegiv interesse</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
